import { IServerPagination } from "app/model"
import { AdvertiserAPI } from "generated-api"

export const DOMAIN_REGEX =
  /^(?=.{1,255}$)[0-9A-Za-z](?:(?:[0-9A-Za-z]|-){0,61}[0-9A-Za-z])?(?:\.[0-9A-Za-z](?:(?:[0-9A-Za-z]|-){0,61}[0-9A-Za-z])?)*\.?$/

export type IAdvertiserDTO = Awaited<ReturnType<typeof AdvertiserAPI.getApiAdvertiserList>>[0]
export type IAdvertiserDomainDTO = Awaited<ReturnType<typeof AdvertiserAPI.getApiAdvertiserDomainList1>>[0]

export interface IAdvertiserDomain extends IAdvertiserDomainDTO {
  normalizedName: string
}

export interface IAdvertiser extends IAdvertiserDTO {
  normalizedName: string
}

export interface IAdvertiserFormData {
  id?: number
  name: string
  media_fee_percent: number | null
}

export type ICreateAdvertiserParams = Parameters<typeof AdvertiserAPI.postApiAdvertiser>[0]
export type IUpdateAdvertiserParams = Parameters<typeof AdvertiserAPI.putApiAdvertiser>[0]
export type ICreateAdvertiserDomainParams = Parameters<typeof AdvertiserAPI.postApiAdvertiserDomain>[1]
export type IUpdateAdvertiserDomainParams = Parameters<typeof AdvertiserAPI.putApiAdvertiserDomain>[0]

export type IAdvertiserFormSaveFn = (newAdvertiser: IAdvertiser) => any

export interface IAdvertiserRepository {
  getAllAdvertisers(): Promise<IAdvertiser[]>
  getAdvertiser(advertiserId: number): Promise<IAdvertiser>
  getAdvertisers(pagination: IServerPagination, filters: IAdvertiserFilters): Promise<IAdvertiser[]>
  getAdvertisersCount(filter?: IAdvertiserFilters): Promise<number>
  createAdvertiser(params: ICreateAdvertiserParams): Promise<IAdvertiser>
  updateAdvertiser(params: IUpdateAdvertiserParams): Promise<IAdvertiser>
  getAdvertiserDomains(advertiserId: number): Promise<IAdvertiserDomain[]>
  getAllAdvertiserDomain(): Promise<IAdvertiserDomain[]>
  createAdvertiserDomain(advertiserId: number, params: ICreateAdvertiserDomainParams): Promise<IAdvertiserDomain>
  updateAdvertiserDomain(params: IUpdateAdvertiserDomainParams): Promise<IAdvertiserDomain>
  deleteAdvertiserDomain(advertiserId: number, advertiserDomainId: number): Promise<void>
}

export interface IAdvertiserService {
  getAllAdvertisers(): Promise<IAdvertiser[]>
  getById(advertiserId: number): IAdvertiser
  getByName(advertiserName: string): IAdvertiser
  createAdvertiser(params: IAdvertiserFormData): Promise<IAdvertiser>
}

export interface IAdvertiserState {
  advertisers: IAdvertiser[]
  advertiserDomains: IAdvertiserDomain[]
  list: IAdvertiserList
  isFormPopupOpened: boolean
  form: IAdvertiserForm
}

export interface IAdvertiserFilters {
  name: string
}

export interface IAdvertiserList {
  filters: IAdvertiserFilters
  isFilterExpanded: boolean
  filteredAdvertisers: IAdvertiser[]
  isRefreshing: boolean
  hasRefreshError: boolean
  pagination: IServerPagination
  rowCount: number
}

export interface IAdvertiserRefreshListParams {
  pagination?: IServerPagination
  filters?: IAdvertiserFilters
}

export type IAdvertiserFormDataErrors = {
  [k in keyof IAdvertiserFormData]?: string
}

export interface IAdvertiserForm {
  isCreation: boolean
  isValid: boolean
  isLoading: boolean
  hasLoadingError: boolean
  isSaving: boolean
  initialData: IAdvertiserFormData
  hasChanged: boolean
  data: IAdvertiserFormData
  errors: IAdvertiserFormDataErrors
  advertiserId: number
}
